if (!customElements.get("product-gallery-modal")) {
  customElements.define(
    "product-gallery-modal",
    class ProductGalleryModal extends ModalDialog {
      constructor() {
        super();

        this.slider = this.querySelector("slider-component");
        this.tip = this.querySelector(".modal-tip");
      }

      show(opener) {
        super.show(opener);
        setTimeout(() => this.showActiveMedia(), 50);

        // 显示操作提示
        if (this.timer) clearTimeout(this.timer);
        this.tip.classList.add("active");
        this.timer = setTimeout(() => {
          this.tip.classList.remove("active");
        }, 5000);
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute("data-media-id");
        if (!mediaId) return;

        if (this.slider && this.slider.initSliderStatus) {
          const currentSlideElement = this.slider.querySelector(
            `.slider-slide[data-media-id='${mediaId}']`,
          );
          if (!currentSlideElement) return;

          this.updateGroupFilter(currentSlideElement);

          if (this.slider.initSliderStatus) {
            this.slider.reInstall();
          }

          this.slider.slideByElement(currentSlideElement);

          const deferredMedia =
            currentSlideElement.querySelector(".deferred-media");
          if (deferredMedia) {
            deferredMedia.loadContent();
          }
        }
      }

      updateGroupFilter(currentSlideElement) {
        if (!this.hasAttribute("data-hide-variants")) {
          this.removeAttribute("data-active-group");
          return;
        }

        const groupName = currentSlideElement?.dataset.mediaGroup;
        this.querySelectorAll(".is-current-variant-media-group").forEach(
          (element) => element.classList.remove("is-current-variant-media-group"),
        );

        if (groupName) {
          this.setAttribute("data-active-group", "");
          this.querySelectorAll(`[data-media-group='${groupName}']`).forEach(
            (element) =>
              element.classList.add("is-current-variant-media-group"),
          );
        } else {
          this.removeAttribute("data-active-group");
        }
      }
    },
  );
}
